import { REGRADE_SET_PAYLOAD, REGRADE_TOGGLE_REGRADING_EDIT_MODE, REGRADE_SET_SCORE_RECONCILIATION } from '@instructure/quiz-common';
export function toggleRegradingEditMode(identifier) {
  return {
    payload: identifier,
    type: REGRADE_TOGGLE_REGRADING_EDIT_MODE
  };
}
export function setRegradingPayload(payload) {
  return {
    payload: payload,
    type: REGRADE_SET_PAYLOAD
  };
}
export function setScoreReconciliation(scoreReconciliation) {
  return {
    type: REGRADE_SET_SCORE_RECONCILIATION,
    payload: scoreReconciliation
  };
}